import React from "react";

export default function WhistleBlowingExplanation(){
    return (
        <div className="container-perusahaan-mitra">
            <div className="yellow-section">
                <h2 className="text-header">Jenis-Jenis Pelanggaran</h2>
                <p>Berikut adalah beberapa jenis pelanggaran yang dapat merugikan perusahaan maupun pemangku kepentingan, dan dapat dilaporkan melalui Whistleblowing System Danai.id:</p>
                <div className='pelanggaran'>
                    <div className='section'>
                        <img src={require('../../../assets/img/whistle-blowing/wb-icon-3.png')} alt='icon 1'/>
                        <p><b>Tindakan fraud atau kecurangan</b><br/>Tindakan yang dilakukan secara sengaja untuk memperoleh keuntungan tidak sah, termasuk namun tidak terbatas pada manipulasi data keuangan, pemalsuan dokumen, atau transaksi fiktif.</p>
                    </div>
                    <div className='section'>
                        <img src={require('../../../assets/img/whistle-blowing/wb-icon-2.png')} alt='icon 2'/>
                        <p><b>Gratifikasi dan suap</b><br/>Penerimaan atau pemberian hadiah, fasilitas, atau bentuk keuntungan lainnya dari atau kepada pihak tertentu yang tidak sesuai dengan ketentuan dan tanpa izin yang sah.</p>
                    </div>
                    <div className='section'>
                        <img src={require('../../../assets/img/whistle-blowing/wb-icon-1.png')} alt='icon 3'/>
                        <p><b>Benturan kepentingan</b><br/>Kondisi di mana individu menggunakan atau berpotensi menggunakan jabatan, wewenang, aset, atau hubungan kerja perusahaan untuk kepentingan pribadi atau pihak lain yang bertentangan dengan kepentingan perusahaan.</p>
                    </div>
                </div>
            </div>
            <div className="penjelasan-produk">
                <div className="produk-inventory">
                    <img className="produk-image"
                         src={require('../../../assets/img/whistle-blowing/whistle-blowing-2.png')}
                         alt='whistle-blowing-2'/>
                    <div className="text-section">
                        <h2 className="text-header">Perlindungan Identitas Pelapor <em>(Whistleblower)</em></h2>
                        <p>Danai.id berkomitmen untuk menjaga kerahasiaan informasi dan identitas Pelapor <em>(Whistleblower)</em>. Setiap laporan yang disampaikan akan dikelola secara aman dan hanya dapat diakses oleh pihak yang berwenang sesuai dengan ketentuan yang berlaku.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}